type EmmaFormKind =
  | 'contact'
  | 'salesman'
  | 'newsletter'
  | 'wallbox'
  | 'callme'
  | 'supplier_contact'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PayloadObject = { [key: string]: any }

type SendEmmaFormParams<T extends PayloadObject> = {
  kind: EmmaFormKind
  file?: File
  payload: T
}

type EmmaFormsResponse<T extends unknown> = {
  id: number
  created_at: string
  kind: EmmaFormKind
  data: T
  file_url?: string
}

const API_URL = `${process.env.API_FORMS_URL}/api/${process.env.API_FORMS_VERSION}/forms`

export const sendEmmaForm = async <T extends PayloadObject>({
  kind,
  file,
  payload,
}: SendEmmaFormParams<T>): Promise<EmmaFormsResponse<T>> => {
  const body = new FormData()
  body.append('kind', kind)
  Object.keys(payload).forEach(paramName => {
    body.append(`data[${paramName}]`, payload[paramName])
  })
  if (file) {
    body.append('file', file, file.name)
  }

  const postRequest = await fetch(API_URL, {
    method: 'post',
    headers: {},
    body,
  })

  const response = await postRequest.json()
  return response
}
